import { createContext, ReactNode, useState } from 'react';

export type ListsDialogsContextProps = {
  dialogOpened: boolean;
  openDialog: () => void;
  closeDialog: () => void;
  firstStepCompleted: boolean;
  pendingRequest: boolean;
  setFirstStepCompleted: (newValue: boolean) => void;
  setPendingRequest: (newValue: boolean) => void;
};

const initialState: ListsDialogsContextProps = {
  dialogOpened: false,
  openDialog: () => {},
  closeDialog: () => {},
  firstStepCompleted: false,
  pendingRequest: false,
  setFirstStepCompleted: () => {},
  setPendingRequest: () => {},
};

const VerificationRequestDialogContext = createContext(initialState);

type VerificationRequestDialogProviderProps = {
  children: ReactNode;
};

const VerificationRequestDialogProvider = ({
  children,
}: VerificationRequestDialogProviderProps) => {
  const [dialogOpened, setDialogOpened] = useState<boolean>(false);
  const [firstStepCompleted, setFirstStepCompleted] = useState<boolean>(false);
  const [pendingRequest, setPendingRequest] = useState<boolean>(false);

  const openDialog = () => {
    setDialogOpened(true);
  };

  const closeDialog = () => {
    setDialogOpened(false);
    setFirstStepCompleted(false);
  };

  return (
    <VerificationRequestDialogContext.Provider
      value={{
        dialogOpened,
        openDialog,
        closeDialog,
        firstStepCompleted,
        pendingRequest,
        setFirstStepCompleted,
        setPendingRequest,
      }}
    >
      {children}
    </VerificationRequestDialogContext.Provider>
  );
};

export { VerificationRequestDialogProvider, VerificationRequestDialogContext };
